export const rootPath = '/';
export const dashboardsPath = 'dashboards';
export const marketAppView = 'marketView/show/dashboard';
export const linksPath = 'v4/dashboards/links';
export const analyticsPath = 'analytics';
export const analysisPath = 'analysis';
export const pagesPath = 'pagesV2';
export const reportsPath = process.env.ENV === 'DEVELOPMENT' ? '' : 'reportsv2';
export const reportsTemplatePath = 'template';
export const analysisRootPath = `${analysisPath}/${analyticsPath}`;
